module.exports = __webpack_public_path__ + "img/ezgif.com-gif-maker-D.f1ea38c8.png";